var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1008,
    height: 617,
    viewBox: "0 0 1008 617",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M992.213 223.759C1046.31 74.3359 942.585 101.07 833.189 33.5435C740.734 -23.5258 583.14 20.6344 464.241 20.6297C211.18 20.6196 134.608 -52.601 52.0711 83.8507C-48.476 250.08 8.67918 451.611 143.018 536.547C310.941 642.716 399.41 614.833 491.824 608.398C584.239 601.964 639.462 521.532 663.129 399.992C686.796 278.452 938.117 373.181 992.213 223.759Z",
    stroke: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm1);
export default __webpack_public_path__ + "static/media/form1.65e218f6a1122f1d9d75a816b8ae1064.svg";
export { ForwardRef as ReactComponent };